export default "__VITE_ASSET__C9E3_nFI__"